
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ApprovalState, Contact, GroupSurveyExtension } from '../../../backend/backendapi';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { dateRangePickerLocale } from '../../../../util/datepicker';
import { camelCase, formatDateTime, vSelectInModalWithPopper } from '../../../../util';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ContactStore from '../../../../stores/ContactStore';
import Approvals from './GeneralAfter/Approvals.vue';
import ExtraInfo from './GeneralAfter/ExtraInfo.vue';
import InformationGroupSelectCheckBoxes from '../../../visitorManagment/advanceRegistration/AdvanceRegistration/InformationGroupSelectCheckBoxes.vue';

type DateRange = { startDate: Date | null, endDate: Date | null };
type DDContact = { contact: Contact; label: string; }

@Component({
  components: {
    Approvals,
    DateRangePicker,
    ExtraInfo,
    InformationGroupSelectCheckBoxes,
    vSelect,
  },
})
export default class GeneralAfter extends Vue {//TODO rename to GeneralAfterForAdvanceRegistration
  @Prop({ required: true })
  readonly group!: GroupSurveyExtension;
  @Prop({ default: true })
  readonly canToggleEnableScanEntry!: boolean;
  @Prop({ default: false })
  readonly hideApprovalStati!: boolean;

  readonly contactsStore = new ContactStore();

  camelCase = camelCase;
  formatDateTime = formatDateTime;
  ApprovalState = ApprovalState;
  vSelectInModalWithPopper = vSelectInModalWithPopper;

  private formatContactLabel(contact: Contact): string {
    const { firstName = '', lastName = '', email, mobile, tel } = contact;

    const name = `${firstName} ${lastName}`.trim();
    // Filter out undefined/null/empty strings and join remaining details with spaces
    const details = [email, mobile, tel].filter(Boolean).join(' ');

    return details ? `${name} (${details})` : name;
  }

  get contacts(): DDContact[] {
    return this.contactsStore.contacts.map(contact => ({
      contact,
      label: this.formatContactLabel(contact),
    }));
  }

  get dateRange(): DateRange {
    return { startDate: this.group.scanEntryStartDate ?? null, endDate: this.group.scanEntryEndDate ?? null };
  }

  set dateRange(dateRange: DateRange) {
    this.group.scanEntryStartDate = dateRange.startDate ?? undefined;
    this.group.scanEntryEndDate = dateRange.endDate ?? undefined;
  }

  get dateRangePickerLocale(): unknown {
    return dateRangePickerLocale(this.$i18n);
  }

  get minDate(): Date {
    return new Date();
  }

  get responsibleContactMsTeamsUrl(): string | null {
    if (!this.group.responsibleContactId) {
      return null;
    }

    const contact = this.contactsStore.contactsById.get(this.group.responsibleContactId);
    if (!contact?.email) {
      return null;
    }
    return 'msteams:/l/call/0/0?users=' + contact.email;
  }

  get responsibleFallbackContactMsTeamsUrl(): string | null {
    if (!this.group.responsibleFallbackContactId) {
      return null;
    }

    const contact = this.contactsStore.contactsById.get(this.group.responsibleFallbackContactId);
    if (!contact?.email) {
      return null;
    }
    return 'msteams:/l/call/0/0?users=' + contact.email;
  }

  get uid(): string {
    return this._uid;
  }

  async mounted(): Promise<void> {
    await this.contactsStore.loadIfAbsent();
  }
}
